import { useContext } from "react";
import { DropzoneAreaBase } from "react-mui-dropzone";
import PropTypes from "prop-types";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "theme";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { MAX_FILE_SIZE } from "constants/attachments";

const MAX_NUMBER_OF_FILES = 50;

export function DropZone({
  setFileUploaded,
  setFileDropped,
  acceptedFiles,
  dropzoneText = "Drag and drop a file here or click to browse",
  filesLimit = MAX_NUMBER_OF_FILES
}) {
  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <DropzoneAreaBase
          fileObjects={[]}
          acceptedFiles={acceptedFiles}
          onAdd={setFileUploaded}
          onDrop={setFileDropped}
          showPreviews={false}
          showPreviewsInDropzone={false}
          maxFileSize={MAX_FILE_SIZE}
          dropzoneText={dropzoneText}
          showAlerts={false}
          filesLimit={filesLimit}
          onAlert={(message, alertType) => {
            if (alertType === "error") {
              addSnackbarToQueue({ message, severity: "error" });
            }
          }}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

DropZone.propTypes = {
  setFileUploaded: PropTypes.func,
  setFileDropped: PropTypes.func,
  acceptedFiles: PropTypes.array,
  dropzoneText: PropTypes.string,
  filesLimit: PropTypes.number
};
